import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, takeUntil, tap } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';
import {
	bulkDeleteDepots,
	bulkDeleteDepotsSuccess,
	deleteDepot,
	deleteDepotSuccess,
	DepotSelector,
} from '../../store';

export enum DepotAction {
	Delete = 'delete',
}

export interface IDepotActionModalData {
	depotId: number | Array<number>;
	element: string;
	action: DepotAction;
}
@Component({
	selector: 'app-depot-action-popup',
	templateUrl: './depot-action-popup.component.html',
	styleUrls: ['./depot-action-popup.component.scss'],
})
export class DepotActionPopupComponent<
	T extends IDepotActionModalData
> extends DcBaseComponent {
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		depotId: number | Array<number>;
		isMultipleElement: boolean;
		action: DepotAction;
		isActionInProgress: boolean;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly DepotAction = DepotAction;
	public constructor(
		private readonly modalService: AppModalService,
		private readonly store: Store,
		private readonly depotSelector: DepotSelector,
		private readonly actions$: Actions,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'depot-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.depotId) && this.modalData.element === '',
			depotId: this.modalData.depotId,
			action: this.modalData.action,
			isActionInProgress: this.depotSelector.getActionInProgress$(),
		});

		this.closeOnActionCompletion();
	}

	public confirmAction(): void {
		const { depotId } = this.modalData;
		if (!Array.isArray(depotId)) {
			return this.store.dispatch(
				deleteDepot({
					depotId,
				})
			);
		}
		if (depotId.length === 1) {
			return this.store.dispatch(
				deleteDepot({
					depotId: depotId[0],
				})
			);
		}
		return this.store.dispatch(
			bulkDeleteDepots({
				depotIds: depotId,
			})
		);
	}

	private closeOnActionCompletion(): void {
		this.actions$
			.pipe(
				takeUntil(this.onDestroy$),
				ofType(deleteDepotSuccess, bulkDeleteDepotsSuccess),
				tap(() => this.modalService.closeActiveModal())
			)
			.subscribe();
	}
}
